(ns livefeed.toast
  (:require
   ["react" :as react]
   ["@yleisradio/yds-components-react" :refer [useToast]]))

(defonce ^:private toast-fn (atom nil))

;; React function component. Must be rendered inside a YDS ToastProvider.
;; Captures the `useToast` function so imperative CLJS code (event handlers,
;; go blocks, etc.) can trigger toasts via `notify!`.
(defn toast-bridge []
  (let [toast (useToast)]
    (react/useEffect
     (fn []
       (reset! toast-fn toast)
       (fn cleanup [] (reset! toast-fn nil)))
     #js [toast])
    nil))

(defn notify! [props]
  (when-let [f @toast-fn]
    (f (clj->js props))))
